import { SxProps, Theme } from '@mui/material';

import { Maybe } from '@shared-components/types';

export const getWrapperStyles = ({
	theme,
	isCompactMode,
	templateWidth,
	shouldApplyDarkOverlay,
	contentPositionSmallScreen,
	mediaAspectRatioSmallScreen,
}: {
	theme: Theme;
	isCompactMode: boolean;
	templateWidth?: Maybe<string>;
	shouldApplyDarkOverlay: boolean;
	contentPositionSmallScreen?: Maybe<string>;
	mediaAspectRatioSmallScreen?: Maybe<string>;
}): SxProps => {
	const getSmallScreenContentPosition = (
		contentPositionSmallScreen?: Maybe<string>,
		mediaAspectRatioSmallScreen?: Maybe<string>
	) => {
		if (contentPositionSmallScreen === 'Top') {
			return mediaAspectRatioSmallScreen === 'Portrait (9:16)' ? 'column' : 'column-reverse';
		}
		if (contentPositionSmallScreen === 'Bottom') {
			return mediaAspectRatioSmallScreen === 'Portrait (9:16)' ? 'column-reverse' : 'column';
		}
	};

	return {
		position: 'relative',
		display: 'contents',
		maxWidth: '100%',
		margin: '0 auto',
		[theme.breakpoints.up('md')]: {
			minHeight: isCompactMode ? 'calc(100vh - 12.5rem)' : '',
			flexDirection: 'column',
			width: templateWidth === 'Inset' ? '90%' : '100%',
		},
		[theme.breakpoints.down('md')]: {
			paddingLeft: '0',
			paddingRight: '0',
			flexDirection: getSmallScreenContentPosition(contentPositionSmallScreen, mediaAspectRatioSmallScreen),
		},
		[theme.breakpoints.down('sm')]: {
			minHeight: isCompactMode ? 'calc(100vh - 5rem)' : '',
		},
		'&:after': {
			content: '""',
			width: '100%',
			backgroundImage: shouldApplyDarkOverlay
				? 'linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))'
				: '',
			position: 'absolute',
			right: 0,
			top: 0,
			zIndex: 1,
		},
	};
};
